import { Log } from '@/types/logs'
import { isAfter } from 'date-fns'

export const sortLogsByTime = (logA: Log, logB: Log): number => {
    const timeA = logA.timestamp
    const timeB = logB.timestamp

    return isAfter(timeB, timeA) ? 1 : isAfter(timeA, timeB) ? -1 : 0
}
